module.exports = __webpack_public_path__ + "components/weather-icon/static/dayclear-90dd83a4982cfa2a3a526f0005f1c7c6.png";